import axios from 'axios';
import { API_HOST } from '../consts';

class ViewSet {
  get url() {
    return `${API_HOST}/${this.prefix}/${this.endpoint}`;
  }

  list = async (params) => {
    const response = await axios.get(this.url, { params });
    return response.data;
  };

  retrieve = async ({ id }) => {
    const response = await axios.get(`${this.url}/${id}`);
    return response.data;
  };

  create = async ({ data }) => {
    const response = await axios.post(this.url, data);
    return response.data;
  };

  action = async ({ name, params, method = 'get', data }) => {
    if (method === 'get') {
      const response = await axios[method](`${this.url}/${name}`, { params });
      return response.data;
    }
    const response = await axios[method](`${this.url}/${name}`, data, {
      params,
    });
    return response.data;
  };
}

export { ViewSet };
